import { IConfig } from '@qunhe/ktracker-types';
import ErrorParser from '../../utils/errorParser';
import { getLocation } from '../../utils/func';
import logger from '../../utils/logger';
import SystemOptions from '../../utils/options';
import { processErrorData, processErrorDataV2 } from '../collector';

export let globalUnhandledRejectionHandler: (event: PromiseRejectionEvent) => void;

export default function unhandledRejection(opts: IConfig) {
  // reference:
  // https://developer.mozilla.org/zh-CN/docs/Web/Events/unhandledrejection
  globalUnhandledRejectionHandler = (event: PromiseRejectionEvent) => {
    const error = event.reason;
    const options = SystemOptions.getInstance().getOptions();

    if (options && options.debug && error) {
      logger.error('window unhandledrejection handler: ' + error.toString());
    }

    if (!error || typeof error === 'string') {
      processErrorData({ message: error || 'unhandled rejection', url: getLocation() }, opts);
    } else {
      const { parsedStack, labels } = ErrorParser.parseStack(error, opts.maxStackDepth);
      processErrorDataV2(parsedStack, opts, labels);
    }
  };

  window.addEventListener('unhandledrejection', globalUnhandledRejectionHandler, false);
}
